import { t } from 'i18next'

import type { ContractListFilterState } from '../hooks/useContractListFilter'

export function generateDeliveryPeriodText(
  filterState: ContractListFilterState,
): string {
  const { fromDate, toDate, filterType } = filterState
  const fromDateText =
    fromDate !== undefined
      ? t('page:contract_list.filter.target_period', {
          year: fromDate?.getFullYear(),
          month: fromDate?.getMonth() + 1,
        })
      : ''
  const toDateText =
    toDate !== undefined
      ? t('page:contract_list.filter.target_period', {
          year: toDate?.getFullYear(),
          month: toDate?.getMonth() + 1,
        })
      : ''
  if (filterType === 'ALL') {
    return t('page:contract_list.filter.all')
  }
  switch (filterType) {
    case 'THIS_MONTH':
      return `${t('page:contract_list.filter.this_month')} (${fromDateText})`
    case 'NEXT_MONTH':
      return `${t('page:contract_list.filter.next_month')} (${fromDateText})`
    case 'CUSTOM':
      return `${t('page:contract_list.filter.custom')} (${fromDateText} - ${toDateText})`
    default:
      return ''
  }
}
export default generateDeliveryPeriodText
